<template>
  <div>
    <form class="login" @submit.prevent="forgetPassword">
      <h1>Passwort zurücksetzen</h1>
      <div class="p-3 mb-2 bg-success text-white" v-if="isEmailSent">Bitte überprüfe deine E-Mail {{maskedEmail}} </div>
      <label>Username</label>
      <input
        required
        v-model="username"
        type="text"
      />
      <hr />
      <button type="submit">zurücksetzen</button>
      <router-link  class="mt-4" to="../login">zurück zur Anmeldung</router-link>
      
    </form>
  </div>
</template>

<style>
.login {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 10px;
}
a {
  color: #2e426b;
  text-decoration: none;
}
</style>

<script>
import axios from "axios";
export default {
  name: "forgetPassword",
  data() {
    return {
      username: "",
      isEmailSent: false,
    };
  },

  methods: {

    forgetPassword: function () {
      this.changePassword(this.username);
    },

    changePassword: function (username) {
      axios({
        method: "GET",
        url: process.env.VUE_APP_API_PATH + "user/ForgotPassword?username="+username,
      }).then(
        (result) => {
          this.username = null;
          this.isEmailSent = true;
          this.maskedEmail = result.data["email"];
        },
        (error) => {
          console.error(error);
          alert("Fehler, Reset fehlgeschlagen!");
        }
      );
    }
  },
};

</script>
